export const Content = {
  "multi-language-content": "multi-language content like the ",
  "start-creating": "Start creating ",
  español: "Español",
  "setup-your-application": "Setup your Application and Environments",
  login: "Login",
  "how-it-works": "How It Works",
  register: "Register",
  "open-enrollment-ends":
    "Open Enrollment ends Jan 15 this year – you can still get health insurance",
  "fluentc-translation": "FluentC Translation Demo",
  "it-is-now-easier":
    "It is now easier than ever to manage all of your translations in one secure and safe platform",
  "you-need-to-enable": "You need to enable JavaScript to run this app.",
  "setup-your-widget": "Setup your Widget",
  "paste-this-code-snippet":
    " Paste this code snippet where your website should list available language.",
  "setup-the-languages": "Setup the Languages for your Website",
  "finish-security-settings": "Finish Security Settings",
  fluentc: "FluentC",
  "looking-for-coverage": "Looking for coverage for a small business?",
  "header-above-using": "header above using ",
  "hero-1":
    "Open Enrollment ends Jan 15 this year – you can still get health insurance",
  close: "Close",
  "create-an-account": "Create an account",
  "register-for-fluentc": "Register for FluentC Account",
  "steps-to-get-started": "Steps to get Started",
  "update-plan": "Find or Update Plan",
  "fluentc-credits-required": "FluentC Credits required after Free Trial",
  "install-your-web": "Install your Web Widget",
  "get-answers": "Get Answers",
  'document.addeventlistener("domcontentloaded",-function':
    '    document.addEventListener("DOMContentLoaded", function () {',
  "register-now": "Register Now",
  "first-time": "First time applying here?",
  "for-all-of-the-options": "For all of the options visit our ",
  documentation: "Documentation",
  "get-coverage": "Get Coverage",
  search: "Search",
  "already-have a-marketplace-plan": "Already have a Marketplace plan?",
  "take-the-first step": "Take the first step to apply",
  "log-in-to-renew": "Log in to renew/change plans",
  "see-topics": "See topics",
  "learn-more": "Learn more",
};
